import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * SalesPersonCustomersMapApi - axios parameter creator
 * @export
 */
const SalesPersonCustomersMapApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBySalesPerson: async (sid, options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/DeleteBySalesPerson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sid !== undefined) {
                localVarQueryParameter['sid'] = sid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: async (sid, options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/GetCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sid !== undefined) {
                localVarQueryParameter['sid'] = sid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkedCustomers: async (options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/GetLinkedCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (SalesPersonCustomersMapToken, options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SalesPersonCustomersMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapTokenArgs} [SalesPersonCustomersMapTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save: async (SalesPersonCustomersMapTokenArgs, options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SalesPersonCustomersMapTokenArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLinkedCustomers: async (SalesPersonCustomersMapToken, options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/SaveLinkedCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SalesPersonCustomersMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSingle: async (SalesPersonCustomersMapToken, options = {}) => {
            const localVarPath = `/v1/SalesPersonCustomersMap/SaveSingle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SalesPersonCustomersMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesPersonCustomersMapApi - functional programming interface
 * @export
 */
const SalesPersonCustomersMapApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesPersonCustomersMapApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBySalesPerson(sid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBySalesPerson(sid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.deleteBySalesPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomers(sid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomers(sid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.getCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinkedCustomers(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkedCustomers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.getLinkedCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(SalesPersonCustomersMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(SalesPersonCustomersMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapTokenArgs} [SalesPersonCustomersMapTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save(SalesPersonCustomersMapTokenArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save(SalesPersonCustomersMapTokenArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.save']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLinkedCustomers(SalesPersonCustomersMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLinkedCustomers(SalesPersonCustomersMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.saveLinkedCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSingle(SalesPersonCustomersMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSingle(SalesPersonCustomersMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonCustomersMapApi.saveSingle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SalesPersonCustomersMapApi - factory interface
 * @export
 */
const SalesPersonCustomersMapApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesPersonCustomersMapApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBySalesPerson(sid, options) {
            return localVarFp.deleteBySalesPerson(sid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(sid, options) {
            return localVarFp.getCustomers(sid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkedCustomers(options) {
            return localVarFp.getLinkedCustomers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(SalesPersonCustomersMapToken, options) {
            return localVarFp.insert(SalesPersonCustomersMapToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapTokenArgs} [SalesPersonCustomersMapTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save(SalesPersonCustomersMapTokenArgs, options) {
            return localVarFp.save(SalesPersonCustomersMapTokenArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLinkedCustomers(SalesPersonCustomersMapToken, options) {
            return localVarFp.saveLinkedCustomers(SalesPersonCustomersMapToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSingle(SalesPersonCustomersMapToken, options) {
            return localVarFp.saveSingle(SalesPersonCustomersMapToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SalesPersonCustomersMapApi - object-oriented interface
 * @export
 * @class SalesPersonCustomersMapApi
 * @extends {BaseAPI}
 */
class SalesPersonCustomersMapApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [sid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    deleteBySalesPerson(sid, options) {
        return SalesPersonCustomersMapApiFp(this.configuration).deleteBySalesPerson(sid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    getAll(options) {
        return SalesPersonCustomersMapApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    getById(id, options) {
        return SalesPersonCustomersMapApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [sid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    getCustomers(sid, options) {
        return SalesPersonCustomersMapApiFp(this.configuration).getCustomers(sid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    getLinkedCustomers(options) {
        return SalesPersonCustomersMapApiFp(this.configuration).getLinkedCustomers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    insert(SalesPersonCustomersMapToken, options) {
        return SalesPersonCustomersMapApiFp(this.configuration).insert(SalesPersonCustomersMapToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    remove(id, options) {
        return SalesPersonCustomersMapApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {SalesPersonCustomersMapTokenArgs} [SalesPersonCustomersMapTokenArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    save(SalesPersonCustomersMapTokenArgs, options) {
        return SalesPersonCustomersMapApiFp(this.configuration).save(SalesPersonCustomersMapTokenArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    saveLinkedCustomers(SalesPersonCustomersMapToken, options) {
        return SalesPersonCustomersMapApiFp(this.configuration).saveLinkedCustomers(SalesPersonCustomersMapToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {SalesPersonCustomersMapToken} [SalesPersonCustomersMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonCustomersMapApi
     */
    saveSingle(SalesPersonCustomersMapToken, options) {
        return SalesPersonCustomersMapApiFp(this.configuration).saveSingle(SalesPersonCustomersMapToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { SalesPersonCustomersMapApi, SalesPersonCustomersMapApiAxiosParamCreator, SalesPersonCustomersMapApiFactory, SalesPersonCustomersMapApiFp };
//# sourceMappingURL=sales-person-customers-map-api.js.map
